export class MapController {

  // =========================
  // 🔹 BASIC MAP MOVEMENT
  // =========================

  panToLocation(map: google.maps.Map | undefined, position: google.maps.LatLng | google.maps.LatLngLiteral | google.maps.LatLngAltitude | google.maps.LatLngAltitudeLiteral | null | undefined, zoom: number = 14) {
    if (!map || !position) {
      return;
    }

    map.panTo(position);
    map.setZoom(zoom);
  }

  fitBounds(map: google.maps.Map | undefined, bounds?: google.maps.LatLngBounds | null) {
    if (!map || !bounds) {
      return;
    }

    map.fitBounds(bounds);
  }
  // =========================
  // 🔹 PLACES CONTROL
  // =========================

  handlePlaceViewport(map: google.maps.Map | undefined, location: google.maps.LatLng, viewport?: google.maps.LatLngBounds | null, zoomFallback = 14) {
    if (!map) {
      return;
    }

    if (viewport) {
      this.fitBounds(map, viewport);
    } else {
      this.panToLocation(map, location, zoomFallback);
    }
  }

  // =========================
  // 🔹 CENTER CONTROL
  // =========================

  createCenterControl(map: google.maps.Map | undefined, iconHtml: string, onClick: () => void): HTMLElement {
    const controlDiv = document.createElement("div");
    controlDiv.classList.add("my-location-container");

    controlDiv.innerHTML = `
      <div class="background">
        ${iconHtml}
      </div>
    `;

    controlDiv.addEventListener("click", onClick, { passive: true });

    if (map) {
      map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(controlDiv);
    }

    return controlDiv;
  }
}